module.exports = __webpack_public_path__ + "static/media/lotus_sound.75338297.mp3";